<template>
  <Card class="tw-mt-4">
    <CardHeader class="tw-pb-3">
      <CardTitle class="tw-text-base tw-font-medium tw-text-neutral-700 dark:tw-text-neutral-300">
        {{ t('payments.titles.related_payments') }}
      </CardTitle>
    </CardHeader>
    <CardContent>
      <!-- Content -->
      <div v-if="relatedPayments.length" class="tw-space-y-2">
        <router-link
          v-for="payment in relatedPayments"
          :key="payment.id"
          :to="{ name: 'payment', params: { id: payment.payment_id } }"
          class="tw-flex tw-items-center tw-justify-between tw-rounded-lg tw-border tw-border-neutral-200 tw-bg-neutral-50 tw-p-3 tw-transition-colors hover:tw-bg-neutral-100 dark:tw-border-neutral-800 dark:tw-bg-neutral-900 dark:hover:tw-bg-neutral-800"
        >
          <div class="tw-flex tw-flex-col tw-gap-1">
            <span class="tw-text-sm tw-font-medium tw-text-neutral-700 dark:tw-text-neutral-300">
              {{ payment.payment_number }}
            </span>
            <span class="tw-text-xs tw-text-neutral-500 dark:tw-text-neutral-400">
              {{ formatDate(payment.payment_date) }}
            </span>
          </div>
          <span class="tw-text-sm tw-font-medium tw-text-neutral-700 dark:tw-text-neutral-300">
            {{ formatCurrency(payment.payment_amount) }}
          </span>
        </router-link>
      </div>

      <!-- Empty State -->
      <div
        v-else
        class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-8 tw-text-center"
      >
        <div class="tw-text-neutral-400 dark:tw-text-neutral-500">
          <CreditCard class="tw-mx-auto tw-h-12 tw-w-12" />
        </div>
        <p class="tw-mt-2 tw-text-sm tw-text-neutral-500 dark:tw-text-neutral-400">
          {{ t('payments.titles.no_related_payments') }}
        </p>
      </div>
    </CardContent>
  </Card>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CreditCard } from 'lucide-vue-next';

const { t } = useI18n();

const props = defineProps({
  order: {
    type: Object,
    default: () => ({}),
  },
});

const relatedPayments = computed(() => {
  return props.order?.related_payments || [];
});

const formatCurrency = (value: any) => {
  if (value === null || value === undefined || value === '') return '-';
  const num = Number(value);
  if (isNaN(num)) return '-';
  return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(num);
};

const formatDate = (value: string | null) => {
  if (!value) return '-';
  return new Date(value).toLocaleDateString('de-DE');
};
</script>
